import React, { useState } from 'react';
import { Modal, IconButton } from '@mui/material';
import { Close as CloseIcon, Fullscreen as FullscreenIcon, FullscreenExit as FullscreenExitIcon } from '@mui/icons-material';
import './style.css';

const IframeModal = ({ open, onClose, url, title }) => {
  const [fullscreen, setFullscreen] = useState(false);

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: 'flex',
        alignItems: fullscreen ? 'flex-start' : 'center',
        justifyContent: fullscreen ? 'flex-start' : 'center',
        padding: fullscreen ? 0 : undefined,
      }}
    >
      <div
        className="iframe-modal-container"
        style={fullscreen
          ? { position: 'fixed', inset: 0, width: '100vw', height: '100vh', borderRadius: 0, zIndex: 1 }
          : {}}
      >
        <div className="iframe-modal-header">
          <h3>{title || 'Nova Tela'}</h3>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <IconButton
              onClick={() => setFullscreen(f => !f)}
              sx={{ color: 'white', '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}
              title={fullscreen ? 'Sair da tela cheia' : 'Tela cheia'}
            >
              {fullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </IconButton>
            <IconButton
              onClick={onClose}
              sx={{
                color: 'white',
                '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.1)' },
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <div className="iframe-modal-content">
          {url && (
            <iframe
              src={url}
              title={title || 'Modal Content'}
              className="iframe-modal-frame"
            />
          )}
        </div>
      </div>
    </Modal>
  );
};

export default IframeModal;
